// Переводы на русский язык
export const ru = {
  common: {
    welcome: "Добро пожаловать",
    logout: "Выйти",
    login: "Войти",
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успех",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    edit: "Редактировать",
    back: "Назад",
    next: "Далее",
    previous: "Предыдущий",
    search: "Поиск",
    filter: "Фильтр",
    close: "Закрыть",
  },
  login: {
    title: "Вход",
    subtitle: "Доступ к вашей учетной записи Auriga",
    button: "Войти через Authentik",
    checking: "Проверка сессии...",
    redirecting: "Перенаправление...",
  },
  dashboard: {
    title: "Панель управления",
    welcome: "Добро пожаловать",
    userInfo: "Информация о пользователе",
    email: "Электронная почта",
    id: "ID",
    apiInfo: "Информация API",
    noUserData: "Информация о пользователе недоступна.",
    sections: "Доступные разделы",
    qualityDashboard: "Панель качества",
    maintenanceDashboard: "Панель обслуживания",
    adminDashboard: "Панель администратора",
    noAccess: "У вас нет доступа к специализированным разделам. Обратитесь к администратору для получения разрешений.",
    permissions: "Информация о разрешениях",
    factories: "Заводы",
    roles: "Роли",
    departments: "Отделы",
    groups: "Группы",
    none: "Нет",
    noneFound: "Нет",
  },
  quality: {
    title: "Панель качества",
    permissions: "Информация о разрешениях",
    accessChecks: "Проверки доступа",
    factoryAccess: "Доступ к",
    roleIn: "Роль",
    features: "Функции качества",
    inspections: "Управление инспекциями",
    qualityControl: "Контроль качества",
    nonConformities: "Отчеты о несоответствиях",
    trends: "Анализ тенденций",
  },
  maintenance: {
    title: "Панель обслуживания",
    permissions: "Информация о разрешениях",
    accessChecks: "Проверки доступа",
    factoryAccess: "Доступ к",
    roleIn: "Роль",
    features: "Функции обслуживания",
    planning: "Планирование обслуживания",
    workOrders: "Рабочие заказы",
    equipment: "Управление оборудованием",
    history: "История обслуживания",
  },
  admin: {
    title: "Панель администратора",
    permissions: "Информация о разрешениях",
    accessChecks: "Проверки доступа",
    group: "Группа",
    features: "Функции администратора",
    users: "Управление пользователями",
    system: "Конфигурация системы",
    reports: "Административные отчеты",
    audit: "Аудит и журналы",
  },
  navigation: {
    dashboards: "Панели мониторинга",
  },
  errors: {
    notAuthenticated: "Не аутентифицирован",
    accessDenied: "Доступ запрещен",
    noPermission: "У вас нет разрешения на доступ к этому разделу.",
    requirements: "Требования",
    factory: "Завод",
    department: "Отдел",
    role: "Роль",
    group: "Группа",
    backToDashboard: "Вернуться на панель управления",
  },
};








